import React from 'react'
import { ContentLayout } from 'components/Layouts'
import { Alert } from '@cmsgov/ds-medicare-gov'
import { useTranslation } from 'react-i18next'
import { MyLink } from 'components/MyLink'
import { useMedicareUrl } from 'hooks/useMedicareUrl'

export interface AccountLockedOutProps {}

export const AccountLockedOut: React.FC<AccountLockedOutProps> = () => {
  const { t } = useTranslation('accountLocked')
  const loginUrl = useMedicareUrl(
    'https://www.medicare.gov/account/login',
    'https://www.medicare.gov/account/login?lang=es-mx'
  )

  return (
    <ContentLayout
      heading={t('heading')}
      width='wide'
    >
      <div className="my-u-pb--4">
        <div className="ds-l-container">
          <Alert variation="error" className="my-u-mb--14">
            <p className="ds-c-alert__text">{t('alert')}</p>
          </Alert>
          <p className="my-u-mb--14">{t('paragraph')}</p>
          <MyLink
            className='ds-c-button ds-c-button--solid my-u-py--6 ds-u-border--0'
            href={loginUrl}
          >
            {t('btn-login')}
          </MyLink>
        </div>
      </div>
    </ContentLayout>
  )
}
